import { defineStore } from 'pinia';
import { ref } from 'vue';
import { connectInvoiceNinja } from '@gigdriver/client';
import { useOrganizationStore } from './organization';

export const useInvoiceNinjaStore = defineStore('invoiceNinja', () => {
  const isConnecting = ref(false);
  const error = ref<string | null>(null);

  async function connect(input: { orgId: string; baseUrl: string; token: string; secret?: string }) {
    try {
      isConnecting.value = true;
      error.value = null;
      const result = await connectInvoiceNinja(input);
      // Refresh the org so invoiceNinjaConnected / companyName are current.
      await useOrganizationStore().selectOrganization(input.orgId);
      return result;
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to connect to Invoice Ninja';
      throw err;
    } finally {
      isConnecting.value = false;
    }
  }

  return { isConnecting, error, connect };
});
